import axios from "axios";
import webConfig from "../configs/web.config";

export const getIsLogin = async () => {
  const token = window.document.cookie.match(/X-XSRF-TOKEN=([^;]+)?/);
  if (token) {
    try {
      let res = await axios.get(
        `/${process.env.REACT_APP_API_CONTEXT}/service/system/common/initMycData`,
        {headers: {"X-XSRF-TOKEN": token[1]}}
      )
      if (res.data && res.data.currUser && res.data.currUser.account) {
        return res.data
      } else {
        return false
      }
    } catch(error) {
      if (error && error.stack && (error.stack.search("Network Error") >= 0 || error.stack.search("SyntaxError") >= 0)) {
        window.location.href = webConfig.goLoginURl(window.location.href);
      } else {
        throw error;
      }
    }
  } else {
    return false
  }
}

